<template lang="pug">

    button.ui.primary.button(@click="persist()") Job befindet sich in Produktion

</template>

<script>
    import * as R from "ramda"

    export default {

        methods: {

            async persist() {
                // Model erstellen
                const model = R.assoc('status', 'IN_PRODUCTION', this.jobModel)

                try {
                    // Model speichern
                    await this.$store.dispatch('jobs/update', { id: model.id, model })

                    // Erfolgsmeldung anzeigen
                    this.$growl.success('Job befindet sich nun in Produktion')
                } catch (e) {
                    this.$growl.fatal('Job konnte nicht in Status `IN_PRODUCTION` gesetzt werden', e)
                }
            }

        },

        props: {

            jobModel: {
                type: Object,
                required: true
            }

        }

    }

</script>
